import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../entities/ErrorEntity";
import SearchResultEntity from "../entities/SearchResultEntity";
import QrBatchEntity from "../entities/QrBatchEntity";

export default interface QrRepository {
    createQrsInBatch(quantity: number, stablishmentId: string): Promise<Either<ErrorEntity, void>>;
    searchQrs(_:{stablishmentId?: string | undefined, page: number, itemsPerPage: number}): Promise<Either<ErrorEntity, SearchResultEntity<QrBatchEntity>>>;
    downloadQrBatch(id: string): Promise<Either<ErrorEntity, void>>;
    reDownloadQrBatch(_: { zipToken: string, stablishmentId: string }): Promise<Either<ErrorEntity, void>>;
    disableQr(id: string): Promise<Either<ErrorEntity, void>>;
}

export const QrRepositoryName = "QrRepository";